export default __webpack_public_path__ + "static/events-dark-4e24c519a1358259741e80f09ad06e2a.png";